import { useFormularioContext } from "view/component/Formulario/Formulario";
import { CampoFormularioProps } from "../RestricaoCampoFormulario"
import { CampoFormularioPropsBuilder } from "./CampoFormularioPropsBuilder";


export const useCampoFormularioProps = (name: string, props?: CampoFormularioProps) => {
  const contexto = useFormularioContext();

  return CampoFormularioPropsBuilder.build(contexto, name, props);
}
